import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError } from "shared/types";

export class CopyEventBlockService {
  static copyEventBlocks = (
    targetEvent: string,
    eventBlocks: string[],
    includeRsvpUsers?: boolean
  ): Promise<any> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.IMPORT_EVENT_BLOCKS(targetEvent),
          data: {
            targetEvent,
            eventBlocks,
            includeRsvpUsers,
          },
        });
        resolve(response as any);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_IMPORT_EVENT_BLOCKS);
        reject(error);
      }
    });
}
